import { Injectable, EventEmitter, isDevMode } from '@angular/core';
import {   } from 'rxjs';
import { ClientSettings, SystemRights } from '../models/contracts/Turbo.Data.Contracts';
import { User } from '../models/contracts/Turbo.Data.Contracts';


@Injectable({
  providedIn: 'root',
})
export class SettingsService {

  public Environment: T4Environment = T4Environment.Production;
  private environmentSpecified: boolean = false;

  private apiBase: string;
  private apiBaseSpecified: boolean = false;

  public appInsightsKey = "";

  public appName: string = "";
  public appVersion: string = "";

    public TurboBID = '';
    public TurboXID = '';
    public AuthorizationToken: any;
    public ImpersonationToken: any;

  public impersonateUser: string;
  public customerUserId: string;

    public rights: string[] = [];
    public may(right: SystemRights) {
      return this.rights.indexOf(SystemRights[right]) >= 0;
    }

    public getToken(): any {
        if (this.ImpersonationToken != undefined) return this.ImpersonationToken;
        if (this.AuthorizationToken != undefined) return this.AuthorizationToken;

        return "";
    }

    private user: User | null;
    public getUser(): User { return this.user!; }    
    public getEffectiveUser(): User {
        if (this.user!.Impersonating) return this.user!.Impersonating as User;

        return this.user!;
    }

    private _clientSettings: ClientSettings;
    public get clientSettings() { return this._clientSettings; }
    public set clientSettings(value: ClientSettings) {
        this._clientSettings = value;
        this.settingsChanged.emit(value);
    }

  constructor() {
    this.authenticationChanged = new EventEmitter();
    this.settingsChanged = new EventEmitter();

    if (isDevMode()) {
      this.setEnvironment(T4Environment.Development);
      this.apiBaseSpecified = true;
    } else {
      this.setEnvironment(T4Environment.Production);
    }
  }


  public setEnvironment(env: T4Environment, override: boolean = false) {
    if (this.environmentSpecified) return;
    if (override) this.environmentSpecified = true;

    this.Environment = env;

    // Do not override if specifically set
    if (this.apiBaseSpecified) return;

    switch (env) {
      case T4Environment.Development:
        this.apiBase = "https://localhost:44310/";
        break;

      case T4Environment.Production:
        this.apiBase = "https://t4api.brenderuprental.com/"; //"https://api.turbo4.net/";
        break;

      case T4Environment.Staging:
        this.apiBase = "https://api-staging.turbo4.net/";
        break;

      case T4Environment.Test:
        this.apiBase = "https://api-test.turbo4.net/";
        break;

      case T4Environment.Anata:
        this.apiBase = "https://t4api-anata.azurewebsites.net/";
        break;
    }

    if (override) this.apiBaseSpecified = true;
  }

  public getApiBase() { return this.apiBase; }
  public setApiBase(uri: string) {
    this.apiBase = uri;
    this.apiBaseSpecified = true;
  }
    /// Authentication
    isAuthenticated(): boolean {
        return !!this.AuthorizationToken;
    }

    public setAutentication(token: string, user: User, isImpersonating: boolean) {
        if (!isImpersonating) {
            this.AuthorizationToken = token;
            this.user = user;
        }
        else {
            this.ImpersonationToken = token;
            this.user!.Impersonating = user;
        }

        this.authenticationChanged.emit(true);
    }

    public clearImpersonation() {
      this.impersonateUser = undefined;
        this.ImpersonationToken = undefined;
        this.user!.Impersonating = undefined;

        this.authenticationChanged.emit(true);
    }

    public authenticationExpired(){
        this.user = null;
        this.AuthorizationToken = undefined;
      this.ImpersonationToken = undefined;
      this.impersonateUser = undefined;

        this.authenticationChanged.emit();
    }


    // Authorization
  public isInAny(roles: Array<string>, useRealUser: boolean = false, brands: Array<string> = null, skipbrands: Array<string> = null) {
        if (!this.isAuthenticated() || !roles) return false;

      var brandName = ""; 
      var userRoles = [];
      if (!useRealUser) {
        if (this.getEffectiveUser().Roles == null) return false;
        else {
          userRoles = this.getEffectiveUser().Roles;
          brandName = this.getEffectiveUser().BrandName;
        }
      } else {
        if (this.getUser().Roles == null) return false;
        else {
          userRoles = this.getUser().Roles;
          brandName = this.getUser().BrandName;
        }
      }

      roles = roles.map(x => x.toLowerCase());
      if (roles.length <= 0) return false;

      for (var i = 0; i < userRoles.length; i++) {
        if (roles.indexOf(userRoles[i].toLowerCase()) >= 0) {
          //When the role check is true, check the brandname if there is a brand to skip sent from route.
          if (skipbrands && skipbrands.length > 0 && userRoles.includes('BusinessManager')) {
            if (brandName && brandName.trim() !== '') {
              if (skipbrands.map(x => x.toLowerCase()).some(b => b == brandName.toLowerCase())) {
                return false;
              }
            }
          }

          //When the role check is true, check the brandname if there is a brands send with the route.
          if (brands && brands.length > 0) {
            if (brandName && brandName.trim() !== '') {
              if (brands.map(x => x.toLowerCase()).some(b => b == brandName.toLowerCase())) {
                return true;
              }
              else return false;
            }
            else return false;
          }
          else {
            return true;
          }
        }
      }

        return false;
    }

    // Events
    public authenticationChanged: EventEmitter<boolean>;
    public settingsChanged: EventEmitter<ClientSettings>;    
}

export enum T4Environment {
  Production,
  Development,
  Staging,
  Test,
  Anata
}
